'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResults = require('./components/SearchResults.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchResults).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-results/index.js
// module id = 924
// module chunks = 0